import type { KeyboardEvent } from 'react';

/** Keep vertical list navigation within the focused region, without intercepting child controls. */
export function handleScrollRegionKeyDown(event: KeyboardEvent<HTMLElement>) {
  if (event.target !== event.currentTarget || event.defaultPrevented ||
      event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
  const list = event.currentTarget;
  const step = Math.max(1, Math.floor(list.clientHeight * 0.9));
  const destination: Record<string, number> = {
    Home: 0, End: list.scrollHeight,
    PageDown: list.scrollTop + step, PageUp: list.scrollTop - step,
    ArrowDown: list.scrollTop + 40, ArrowUp: list.scrollTop - 40
  };
  if (!Object.prototype.hasOwnProperty.call(destination, event.key)) return;
  event.preventDefault();
  list.scrollTo({ top: destination[event.key], behavior: 'instant' });
}
